import UseCaseUI from '@/viewer/presentation/react/useCase/useCaseUI';

const UseCase = () => {
  return <UseCaseUI />
}

export default UseCase